import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpHeaders,
  HttpContextToken,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';

// La tua service che estrae/refresh-a il token e compone gli headers
import { BaseAuthenticatedService } from '@app/services/base-authenticated.service';
import { ADD_BACKEND_AUTH } from './auth.tokens';

// HttpContextToken per saltare l'auth quando serve: req.context.set(ADD_BACKEND_AUTH, true)

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private authSvc: BaseAuthenticatedService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // Permetti di saltare l'auth per specifiche richieste
    if (!req.context.get(ADD_BACKEND_AUTH)) {
      return next.handle(req);
    }

    // Se è FormData, non forzare il Content-Type (lascia che il browser setti boundary)
    const wantsMultipart =
      req.body instanceof FormData ||
      req.headers.get('Content-Type') === 'multipart/form-data';

    // Headers di base (se hai dei default lato chiamante rimangono)
    const baseHeaders: { [key: string]: string } = {};
    if (wantsMultipart) {
      baseHeaders['Content-Type'] = 'multipart/form-data';
    } else {
      baseHeaders['Content-Type'] =
        req.headers.get('Content-Type') ?? 'application/json';
    }

    // Chiedi alla tua service gli header completi (gestisce FToken/refresh)
    return this.authSvc.getAuthHeaders(baseHeaders).pipe(
      switchMap((authHeaders: HttpHeaders) => {
        let headers = authHeaders;

        // Unisci eventuali header originali della request (senza sovrascrivere Authorization)
        req.headers.keys().forEach((k) => {
          if (k.toLowerCase() !== 'authorization') {
            const val = req.headers.get(k);
            if (val !== null) headers = headers.set(k, val);
          }
        });

        // Per FormData rimuovi il Content-Type così il browser imposta il boundary giusto
        if (
          wantsMultipart &&
          headers.get('Content-Type') === 'multipart/form-data'
        ) {
          headers = headers.delete('Content-Type');
        }

        const authReq = req.clone({ headers });
        return next.handle(authReq);
      })
    );
  }
}

// import { APIS } from 'prowodo-angular-client/api/api';
